import Model from '../../ModelBinding/Model';
import OfferCollection from './OfferCollection';
import ProductCollection from '../Product/ProductCollection';
import OptionCollection from '../Option/OptionCollection';
import Organization from '../Organization/Organization';
import dayjs from 'dayjs';
import { formatCurrency } from '../../Helpers/FormatNumber';
import Member from '../Member/Member';
import GuidelineCollection from '../Guideline/GuidelineCollection';

export default class Offer extends Model {
  public name?: string;
  public description?: string;
  public price?: number;
  public operator_rate?: number;
  public organization_id?: string;
  public vertical?: string;
  public created_by?: Member;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public products?: ProductCollection;
  public options?: OptionCollection;
  public organization?: Organization;
  public offers?: OfferCollection;
  public guidelines?: GuidelineCollection;
  public currency?: string;
  public category_code?:string;
  public operator_currency?: string;
  public ordered?: boolean;
  public enabled?: boolean;
  public is_visible?: boolean;

  bind() {
    this.name = this.getStringAttribute('name');
    this.description = this.getStringAttribute('description');
    this.price = this.getIntAttribute('price');
    this.operator_rate = this.getIntAttribute('operator_rate');
    this.organization_id = this.getStringAttribute('organization_id');
    this.vertical = this.getStringAttribute('vertical');
    this.created_by = this.getRelationAttribute('created_by', Member) as Member;
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.products = this.getRelationCollection('products', ProductCollection) as ProductCollection;
    this.options = this.getRelationCollection('options', OptionCollection) as OptionCollection;
    this.organization = this.getRelation('organization', Organization) as Organization;
    this.offers = this.getRelationCollection('offers', OfferCollection) as OfferCollection;
    this.guidelines = this.getRelationCollection(
      'guidelines',
      GuidelineCollection,
    ) as GuidelineCollection;
    this.currency = this.getStringAttribute('currency');
    this.category_code = this.getStringAttribute('category_code');
    this.operator_currency = this.getStringAttribute('operator_currency');
    this.ordered = this.getBooleanAttribute('ordered');
    this.enabled = this.getBooleanAttribute('enabled');
    this.is_visible = this.getBooleanAttribute('is_visible');
  }

  static getCollection() {
    return OfferCollection;
  }

  get displayName() {
    return this.name;
  }

  get displayDescription() {
    return this.description;
  }

  get displayPrice() {
    if (!this.price) return 0;
    return formatCurrency(this.price / 100, this.currency);
  }
}
